import React from 'react';
import { GoAlertFill } from "react-icons/go";
import { LuAlignJustify } from "react-icons/lu";

/**Post-Editing Module */
const PostEditing = () => {
  return (
    <div className='mt-1 w-100'>
      <div className='row'>
        <div className="d-flex fn_Roboto border-bottom py-2 align-items-center position-sticky top-0 bg-white">
          <h4 className='fs_20 fw_400 fn_Roboto mx-3'>Post-Editing</h4>
          <h4 className='fs_16 fn_Roboto fw_400 cursor_pointer' style={{ marginLeft: '1rem', marginRight: '1rem' }}>+ CREATE POST-EDITING GROUP</h4>
          <h4 className='fs_16 fn_Roboto fw_400 cursor_pointer' style={{ marginLeft: '1rem', marginRight: '1rem', color: '#3995E7' }}><LuAlignJustify /> VIEW CREATE ACTIVITY</h4>
        </div>
        <div className="postheader mt-3 mx-4">

          <div style={{ marginTop: '2rem' }}></div>
          <div className="model-links">
            <a href="#native-models">POST-EDITING GROUPS</a>
            <a href="#legacy-models">POST-EDITING JOBS</a>
          </div>
          <div style={{ marginTop: '1rem' }}></div>
          <div className="grayheader d-flex">
            <GoAlertFill className='d-flex align-item-left' style={{ color: '#DC6D00' }} /> <p className="paragraph-right">This is available in Advanced portal only.</p>
          </div>
          <br></br>
          <p className="paragraph-right">A post-editing job is a post-edit request submitted by a portal user. The following table shows the status of all jobs from all portals.</p>
          <table className="table">
            <thead>
              <tr>
                <th className="table-header">Group Name</th>
                <th className="table-header">Translators</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan="2">No rows to display</td>
              </tr>
            </tbody>
          </table>

        </div>
      </div>
    </div>

  );
};

export default PostEditing;